export default __webpack_public_path__ + "static/media/q9_step4.63fbb94d.png";